<template>
  <div class="base-button-container">
    <component
      class="base-button"
      :to="route"
      :is="component"
      :class="[
        colorClass,
        {'button-primary--is-disabled' : disabled},
        {'base-button--is-delayed-hover' : delayHover},
        {'base-button--is-hover' : isHover}
      ]"
      :type="buttonType"
      v-on="inputListeners">
      <span
        class="base-button__text"
        :class="[textColorClass]">
        {{buttonText}}
      </span>
    </component>
  </div>
</template>

<script>
export default {
  name: 'BaseButton',
  data () {
    return {}
  },
  inheritAttrs: false,
  props: {
    route: Object,
    buttonText: {
      type: String,
      default: 'Läs mer'
    },
    color: {
      type: String,
      default: 'white'
    },
    disabled: Boolean,
    isSubmit: Boolean,
    delayHover: Boolean,
    isHover: Boolean
  },
  computed: {
    inputListeners () {
      return Object.assign({},
        this.$listeners
      )
    },
    colorClass: function () {
      return (this.color ? 'base-button--mod-color-' + this.color : '')
    },
    textColorClass: function () {
      return (this.color ? 'base-button__text--mod-color-' + this.color : '')
    },
    component: function () {
      return this.route ? 'router-link' : 'button'
    },
    buttonType: function () {
      return this.route ? null : this.isSubmit ? 'submit' : 'button'
    }
  }
}
</script>

<style lang="scss" scoped>
  @import './base-button'
</style>



// WEBPACK FOOTER //
// src/components/BaseButton/BaseButton.vue